import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from '../../../utils/utilservice';
import { AUDIENCE_TXT } from '../../../utils/utils';
import { AudienceLookalikeDetails } from './audience-lookalike-details.interface';

@Component({
  selector: 'lib-look-like-model-view',
  standalone: false,
  templateUrl: './look-like-model-view.component.html',
  styleUrls: ['./look-like-model-view.component.sass']
})
export class LookLikeModelViewComponent implements OnInit {
  audienceLookalikeDetails: AudienceLookalikeDetails | undefined;
  audiencesRouter: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private utilsService: UtilsService
  ) {}

  ngOnInit() {
    const contextId = this.route.snapshot.paramMap.get('contextId');
    this.audiencesRouter = `/${this.utilsService.getProductBaseUrl(
      this.router,
      this.route
    )}/${contextId}/${AUDIENCE_TXT}`;
    this.route.data.subscribe((data: any) => {
      this.audienceLookalikeDetails = data.audienceLookalikeDetails?.data;
    });
  }

  navigateToLookalikesDetails() {
    if (this.audienceLookalikeDetails?.lookalikeModel?.id) {
      this.router.navigate([
        this.utilsService.getProductBaseUrl(this.router, this.route),
        'lookalikes',
        this.audienceLookalikeDetails.lookalikeModel.id
      ]);
    }
  }
}
